import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsClarityEnabled } from 'redux/config/config.selectors';
import { ClarityProxy } from 'util/clarity';
import { linkClarityToSentry } from 'util/clarity-session';
import { getEnv } from 'util/getEnv';

const InitClarity = ({ children }) => {
  const isClarityEnabled = useSelector(selectIsClarityEnabled);

  useEffect(() => {
    if (isClarityEnabled) {
      ClarityProxy.init(getEnv('REACT_APP_MS_CLARITY_PROJECT_ID'));
      linkClarityToSentry();
    }
  }, [isClarityEnabled]);

  return children;
};

export default InitClarity;
